import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NotifierService } from 'angular-notifier';
import { BoobleModalService } from 'booble-modal';

import { InboundOrderDto } from 'src/app/domain/models/dto/inbound-order.dto';
import { OrdersService } from 'src/app/shared/services/orders.service';
import { SuccessModalComponent } from '../../shared/modals/success-modal/success-modal.component';
import { ReviewOrderDto } from 'src/app/domain/models/dto/review-order.dto';
import { CancelOrderDto } from 'src/app/domain/models/dto/cancel-order.dto';

@Component({
  selector: 'app-order-review-reproved-modal',
  templateUrl: './order-review-reproved-modal.component.html',
  styleUrls: ['./order-review-reproved-modal.component.scss'],
})
export class OrderReviewReprovedModalComponent implements OnInit {
  boobleModalData: { type: string; order: InboundOrderDto };
  private readonly notifier: NotifierService;
  public loading: boolean;
  reprovedForm: FormGroup;
  onlySpace: boolean;

  constructor(
    private modalService: BoobleModalService,
    private fb: FormBuilder,
    private readonly ordersService: OrdersService,
    notifierService: NotifierService
  ) {
    this.notifier = notifierService;
    this.reprovedForm = fb.group({
      reprovedMsg: ['', [Validators.required, Validators.pattern('.*\\S.*')]],
    });
  }

  get reprovedFormControl() {
    return this.reprovedForm.controls;
  }

  get reprovedMsg(): any {
    const reprovedMsg = this.reprovedForm.value;
    return reprovedMsg;
  }

  ngOnInit() {}

  closeModal() {
    this.modalService.dismiss(null);
  }

  sendReprove() {
    if (this.reprovedForm.valid) {
      if (this.boobleModalData.type == 'repprove') {
        this.loading = true;
        this.boobleModalData.order.approved = false;
        this.boobleModalData.order.reprovedMsg =
          this.reprovedMsg.reprovedMsg.trim();

        const reprovedData = new ReviewOrderDto();

        (reprovedData.id = this.boobleModalData.order.id),
          (reprovedData.approved = false),
          (reprovedData.reprovedMsg = this.reprovedMsg.reprovedMsg);
        this.ordersService.orderReview(reprovedData).subscribe({
          next: (orderResult) => {
            this.loading = false;
            this.closeModal();
            this.notifier.notify('success', 'Ordem reprovada com sucesso.');
            this.ordersService.updateOrderView();
          },
          error: (err) => {
            this.loading = false;
          },
        });
      } else if (this.boobleModalData.type == 'cancel') {
        this.loading = true;
        this.boobleModalData.order.reprovedMsg =
          this.reprovedMsg.reprovedMsg.trim();

        const canceledData = new CancelOrderDto();

        (canceledData.id = this.boobleModalData.order.id),
          (canceledData.canceledMessage = this.reprovedMsg.reprovedMsg);

        this.ordersService.cancelOrder(canceledData).subscribe({
          next: (orderResult) => {
            this.loading = false;
            this.closeModal();
            this.notifier.notify('success', 'Ordem cancelada com sucesso.');
            this.ordersService.updateOrderView();
          },
          error: (err) => {
            this.loading = false;
          },
        });
      }
    }
  }

  openOrderReviewSuccessModal() {
    this.modalService.present(SuccessModalComponent);
  }
}
